import type { IconGlyph } from '../icon';

import { iconTimelineThick } from './timeline-thick';

/**
 * Tractie `timeline` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/timeline.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconTimeline: IconGlyph = {
  name: 'timeline',
  path: 'M4.5 8h9c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-9C3.67 4 3 4.67 3 5.5v1C3 7.33 3.67 8 4.5 8M4 5.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-9c-.28 0-.5-.22-.5-.5zM9.5 16h-5c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5m.5 2.5c0 .28-.22.5-.5.5h-5c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5zm9.5-8.5h-12c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h12c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5m.5 2.5c0 .28-.22.5-.5.5h-12c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h12c.28 0 .5.22.5.5z',
  selected: iconTimelineThick,
};
